import React from "react";
import { Row, Col } from "react-bootstrap";
import '../../../src/App.css';
import './FeatureSection.css'

import doll from '../../assets/Julian_con_ordenador.png';
import feature from '../../assets/features_logo.png';
import big from '../../assets/big_data_logo.png';
import ia from '../../assets/IA.png';
import cerebro from '../../assets/cerebro_component.png';
import crecimiento from '../../assets/crecimiento.png';

const FeatureSection = () => {
  return (
    <section>
      <Row>        
        {/* Icono */}
        <Col lg={4} className="contenedor-doll paddingTop50px">
          <img src={doll} alt="Icons" className="img-fluid" />
        </Col>
        {/* Las descripciones */}
        <Col lg={8} className="paddingTop50px">
          {/* Row para el Logo Feature y el Título de las descripciones*/}
          <Row>
            <Col lg={10}>
              <img src={feature} alt="Doll" className="img-fluid"/>
              <p className="fs-1 font-nunito fw-bold text-start feature_title">
                Soluciones Profesionales<br/>
                Basadas en Datos
              </p>
            </Col>            
          </Row>
          {/* Row para Las 2 primeras descripciones */}
          <Row>
            <Col lg={10}>
              <Row>
                <Col lg={1}>
                  <img src={crecimiento} alt="Crecimiento" className="float-start"/>
                </Col>
                <Col lg={5} className="text-start">
                  <p className="fs-5 font-montserrat description_feature_title">Crecimiento</p>
                  <p className="fs-6 font-inter features_descriptions">
                    Tu competencia ya está usando los <br />
                    datos para crecer.
                  </p>
                </Col>
                <Col lg={1}>
                <img src={ia} alt="IA" className="float-start"/>
                </Col>
                <Col lg={5} className="fs-5 font-montserrat text-start">
                  <p className="fs-5 font-montserrat description_feature_title">Optimización de IA</p>
                  <p className="fs-6 font-inter features_descriptions">
                    Las empresas que usan IA ya<br />
                    ganan hasta un 20% más de mercado.
                  </p>
                </Col>
              </Row>                          
            </Col>            
          </Row>
          {/* Row para Las 2 segundas descripciones */}
          <Row>
            <Col lg={10}>
              <Row>
                <Col lg={1}>
                  <img src={big} alt="Big Data" className="float-start"/>
                </Col>
                <Col lg={5} className="text-start">
                  <p className="fs-5 font-montserrat description_feature_title">Soluciones de Big Data</p>
                  <p className="fs-6 font-inter features_descriptions">
                    Gestionando tus datos ganarás <br />
                    ventaja sobre la cuota de mercado.
                  </p>
                </Col>
                <Col lg={1}>
                  <img src={cerebro} alt="Cerebro" className="float-start"/>
                </Col>
                <Col lg={5} className="fs-5 font-montserrat text-start">
                  <p className="fs-5 font-montserrat description_feature_title">Machine Learning</p>
                  <p className="fs-6 font-inter features_descriptions">
                    Anticipa patrones de ventas <br />
                    antes que tus competidores.
                  </p>
                </Col>
              </Row>
            </Col>            
          </Row>
        </Col> 
        {/* Fin de las descripciones */}
      </Row>
      <Col lg={12} className="marginTop5_per">
        <p className="fs-5 font-montserrat text-center custom-bg spacing_letter_6px">
          Tus competidores ya usan datos. No te quedes atrás.
        </p>
      </Col>
    </section>
      
  );
};

export default FeatureSection;



